export const smoothScrollToSection = (targetId) => {
    console.log(targetId);
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
        targetSection.scrollIntoView({
        behavior: 'smooth'
        });
    }
};